import React from "react";
import Slide from "react-reveal";
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const Resume = (props) => {
  const [expanded, setExpanded] = React.useState(false);
  
  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  if (!props.data) return null;

  return (
    <section id="resume">
      <h3 className="title">{props.data.sectionName}</h3>
      {props.data.rowKeys.map((key) => {
        return(
          <div className={"row"}>
          <Accordion expanded={expanded === key} onChange={handleChange(key)}>
            <AccordionSummary 
              expandIcon={<ExpandMoreIcon />}
              aria-controls={key + "-panel1bh-content"}
              id={key + "-header"}
            >
                 <div className={"row " + key}>
                  <div className="three columns header-col">
                    <h1>
                      <span>{props.data[key].name}</span>
                    </h1>
                  </div>
                </div>
            </AccordionSummary>
            <AccordionDetails>
              <Slide left duration={1300}>
              <div className={"row"}>
                  <div className="nine columns main-col">
                    <div className="row item">
                      <div className="twelve columns">
                        <div key={key}>
                        <p className="info">
                          <em className="category">{props.data[key].categoryOne}</em>
                        </p>
                        <p className="info">
                          <em className="date">{props.data[key].instruments}</em>
                        </p>
                        <p className="info">
                        <em className="category">{props.data[key].categoryTwo}</em>
                        </p>
                        <p className="info">
                          <em className="subcat">{props.data[key].categoryTwoPointOne}</em>
                        </p>
                        <p className="info">
                          <em className="date">{props.data[key].women}</em>
                        </p>
                        <p className="info">
                          <em className="subcat">{props.data[key].categoryTwoPointTwo}</em>
                        </p>
                        <p className="info">
                          <em className="date">{props.data[key].men}</em>
                        </p>
                        <p className="info">
                          <em className="date">{props.data[key].clothes}</em>
                        </p>
                        <p className="info">
                          <em className="category">{props.data[key].categoryThree}</em>
                        </p>
                        <p className="info">
                          <em className="date">{props.data[key].description}</em>
                        </p>
                        <img src={props.data[key].img}/>
                      </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Slide>
            </AccordionDetails>
          </Accordion>
          </div>
        )
      })}
    </section>
  );
}

export default Resume;
